var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',_vm._b({attrs:{"no-close-on-esc":"","no-close-on-backdrop":""},on:{"hide":_vm.doCancel},scopedSlots:_vm._u([(_vm.$slots[_vm.publicSlots.title] != null)?{key:"modal-title",fn:function(){return [_vm._t(_vm.publicSlots.title)]},proxy:true}:null,{key:"modal-footer",fn:function(){return [(_vm.$slots[_vm.publicSlots.footer] == null)?_c('span'):_vm._e(),_vm._t(_vm.publicSlots.footer)]},proxy:true}],null,true)},'b-modal',{
        scrollable: true,
        centered: true,
        'header-bg-variant': 'light',
        'header-text-variant': 'dark',
        'footer-bg-variant': 'light',
        'footer-text-variant': 'dark',
        ..._vm.$attrs,
        ..._vm.$props,
        title: _vm.$_(_vm.label),
        visible: _vm.innateVisible,
    },false),[_vm._t("default",function(){return [_c('div',{directives:[{name:"show-child-exists",rawName:"v-show-child-exists"}]},[_vm._v(_vm._s(_vm.innateValue))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }